var React = require('react');

function IcShareFb (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M31 16c0-8.284-6.716-15-15-15C7.716 1 1 7.716 1 16c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15zm-13.853-4.096h1.993V9.721h-1.993c-1.65 0-2.852 1.408-2.852 3.14v1.207h-2.133v2.051h2.133v6.16h2.353v-6.16h2.492v-2.051h-2.492v-1.44c0-.414.263-.724.499-.724z","fill":"currentColor"}));
}

IcShareFb.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = IcShareFb;

IcShareFb.default = IcShareFb;
